import { useEffect, useState } from 'react';
import { createEquipmentDraftClient } from '../utils/equipmentDraft';

export default function useEquipmentDraft() {
  const [state, setState] = useState({ ready: false, status: 'idle', error: '' });
  const [client] = useState(() => {
    let storage;
    try { storage = window.localStorage; } catch { /* private browsing can disable storage */ }
    return createEquipmentDraftClient({ storage, onStatus: (status, error = '') => setState((prev) => ({ ...prev, status, error })) });
  });
  useEffect(() => {
    let mounted = true;
    client.restore().catch(() => {}).finally(() => {
      if (mounted) setState((prev) => ({ ...prev, ready: true }));
    });
    const retry = () => client.flush().catch(() => {});
    const leave = () => client.flush('save', { keepalive: true }).catch(() => {});
    const visibility = () => { if (document.visibilityState === 'hidden') leave(); };
    window.addEventListener('online', retry);
    window.addEventListener('pagehide', leave);
    document.addEventListener('visibilitychange', visibility);
    return () => {
      mounted = false;
      client.cancelTimer();
      window.removeEventListener('online', retry);
      window.removeEventListener('pagehide', leave);
      document.removeEventListener('visibilitychange', visibility);
    };
  }, [client]);
  return { ...state, client };
}
